import React, { useRef } from 'react'
import { InputStyles, SelectStyle } from './styled.components'
import { Autocomplete, FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material'

export const InputModal = (props:any, inputProps:any) => {
  return (
    <InputStyles {...props} {...inputProps} fullWidth={props.notFull ? false : true} variant='standard' size='normal'  sx={{ m: 1, minWidth: props.minWidth ? props.minWidth : 170 }} />
  )
}

export const SelectMultiple = (props:any) => {
  return (
    <SelectStyle error={props.error} fullWidth={props.notFull ? false : true} variant="standard" sx={{ m: 1, minWidth: props.minWidth ? props.minWidth : 170 }}>
      <InputLabel id="demo-multiple-checkbox-label">{props.label}</InputLabel>
      <Select
        {...props}
        multiple
        size="normal"
        style={{wordBreak:"break-word"}}
      >
        {props.children}
      </Select>
      {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
    </SelectStyle>
  )
}

